<template>
  <div v-if="isShow" class="defend-wrap">
    <!-- 닫기 버튼 -->
    <a href="#" class="defend-close" @click.prevent="close()">
      <span class="a11y-hidden">나가기</span>
      <CloseWhite></CloseWhite>
    </a>

    <!-- NOTE: case1-해지신청한 유저가 리워드를 받았을 떄 -->
    <div
      v-if="isUnsubscribe && isGetRewords"
      class="defend-contents defend-type01 tac"
    >
      <h1>감사합니다.</h1>
      <span class="con-txt con-txt01">
        코인이 지급되었습니다.<br />
        보너스 코인은 <b class="fc-pink">MY > 코인내역</b>에서 <br />확인하실 수
        있습니다.
      </span>
      <span class="con-dotted tal">
        <i class="icon-dotted"></i> 웨이브 코인 : 방송VOD 단건, 영화 단건 구매
        시 사용 가능
      </span>
      <span class="con-dotted tal">
        <i class="icon-dotted"></i> 다음 결제일에 이용권이 정상결제됩니다.
      </span>
      <span class="con-dotted tal">
        <i class="icon-dotted"></i> 보너스 코인을 사용한 경우 전자상거래법 등
        관련 법률에 따라 해지 신청이 제한될 수 있습니다.<br />
      </span>
      <div class="btn-pink marB0">
        <a href="#" @click.prevent="close()">확인</a>
      </div>
    </div>

    <!-- NOTE: case2.1-해지 버튼 클릭 시 첫번째 스텝 - 그냥 해지 팝업 (방어x) -->
    <template v-else-if="isUnsubscribe && step === 0">
      <div class="defend-top defend-info01 step1">
        <Ticket alt="ticket" />
        <h1>잠시만요!</h1>
        <p class="coin-text">
          <span>지금 해지하시면 <strong>매주 업데이트 되는</strong></span>
          <span
            ><strong>다양한 영화와 해외 시리즈</strong>들을 더 이상 볼 수
            없어요!</span
          >
          <span class="coin-text1">정말 해지하시겠어요?</span>
        </p>
      </div>
      <!--// defend-top -->
      <div class="defend-contents">
        <div class="ticket-table">
          <table>
            <colgroup>
              <col width="92px" />
              <col width="*" />
            </colgroup>
            <tbody>
              <tr>
                <th><b>이용권명</b></th>
                <td>
                  <div>
                    {{ voucherData.productname }}
                  </div>
                  <div v-html="voucherDescription"></div>
                </td>
              </tr>
              <tr>
                <th><b>잔여기간</b></th>
                <td v-if="isUpcomingpayment">
                  지금 이용권 예약을 취소해도<br />
                  남은 쿠폰 기간 동안 웨이브를 이용할 수 있어요.
                </td>
                <td v-else>
                  지금 이용권을 해지해도 {{ remainingTime }}까지는<br />계속
                  웨이브를 이용할 수 있어요.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="tac">
          <span class="con-txt">
            <span style="color: #fff"
              >해지하실 이용권을 다시 한 번 확인해 주세요.</span
            >
            <span class="coin-text2"
              >LIVE 전용 이용권은 해외 시리즈 및 영화 감상 미제공<br
            /></span>
          </span>
        </div>
        <ul class="terms-list">
          <li class="terms-item">
            <span
              >이용권 구매 후 콘텐츠 미사용 시, 7일 이내에 청약 철회가
              가능합니다.</span
            >
          </li>
          <li class="terms-item">
            <span
              >이용권 구매 후 7일이 경과 되었거나 콘텐츠를 사용한 경우 부분
              환불이 진행될 수 있습니다. (할인 이벤트를 받아 이용권을 구매한
              경우 할인 미적용 기준으로 환불 금액이 정산 됩니다.)</span
            >
          </li>
          <li class="terms-item">
            <span
              >이용권 구매 후 청약 철회 또는 부분 환불을 원하시면 웨이브
              <a :href="getInquiryUrl()" :style="highlightTextStyle">고객센터</a
              >에 연락해 주시기 바랍니다.</span
            >
          </li>
        </ul>
        <div class="bottom-button-container">
          <div class="btn-pink mr-8">
            <a href="#" @click.prevent="close()">취소</a>
          </div>
          <div class="btn-pink">
            <a href="#" @click.prevent="checkPromotion()">해지</a>
          </div>
        </div>
      </div>
    </template>

    <!-- NOTE: case2.2-해지팝업에서 "해지" 버튼 누르면 해지 방어 팝업으로 스텝 이동 -->
    <template v-else-if="isUnsubscribe && step === 1">
      <div class="defend-top defend-info01 step2">
        <GiftCoin class="coin-info" alt="gift-coin"></GiftCoin>
        <p class="coin-text">
          <span>이용권을 유지하면 감사의 의미로</span>
          <span
            ><b>{{ coinText }}</b
            >을 드려요.</span
          >
          <span class="coin-text1"
            >코인 받고 다양한 최신 영화를 감상해 보시겠어요?</span
          >
        </p>
      </div>
      <!--// defend-top -->
      <div class="defend-contents">
        <span class="con-tit">이용권 유지 시 혜택!</span>
        <span
          v-for="(message, index) in promotionMessage"
          :key="'step_1' + index"
          class="con-dotted"
        >
          <i class="icon-dotted"></i>
          <span v-html="message"></span>
        </span>
        <div class="btn-pink">
          <a href="#" @click.prevent.once="getRewords">유지하고 코인 받기</a>
        </div>
        <div class="tar">
          <p class="revocation-exclamation">
            <span
              >보너스 코인을 사용한 경우 전자상거래법 등 관련 법률에 따라 해지
              신청이 제한될 수 있습니다.</span
            >
            <span
              >코인 수령 시 32일 이후 해지신청이 가능하며, 코인을 사용하지 않은
              경우 고객센터를 통해 즉시 해지신청을 요청 할 수 있습니다.</span
            >
          </p>
          <a href="#" class="gray-arrow" @click.prevent="unsubscribe"
            ><span>해지하기</span><NextButtonBlack
          /></a>
        </div>
      </div>
      <!--// defend-contents -->
    </template>

    <!-- NOTE: case2.3-해지팝업-그냥 해지 계속 진행/이 케이스는 본적 없음 -->
    <template v-else-if="isUnsubscribe && step === 2">
      <div class="defend-top defend-info02">
        <p>해지 이유를 남겨주세요.</p>
      </div>
      <div class="defend-contents">
        <span class="con-tit"
          >답해주신 소중한 정보를 바탕으로, 더 나은<br />서비스로
          보답하겠습니다.</span
        >
        <ul class="reason-list">
          <li>
            <div class="radio-style">
              <input
                id="reason01"
                v-model="cancelDescription"
                type="radio"
                class="radio-pink"
                name="reason"
                value="찾는 콘텐츠가 별로 없어서"
              />
              <label for="reason01">찾는 콘텐츠가 별로 없어서</label>
            </div>
          </li>
          <li>
            <div class="radio-style">
              <input
                id="reason02"
                v-model="cancelDescription"
                type="radio"
                class="radio-pink"
                name="reason"
                value="서비스 이용이 불편해서"
              />
              <label for="reason02">서비스 이용이 불편해서</label>
            </div>
          </li>
          <li>
            <div class="radio-style">
              <input
                id="reason03"
                v-model="cancelDescription"
                type="radio"
                class="radio-pink"
                name="reason"
                value="이용 가격이 비싸서"
              />
              <label for="reason03">이용 가격이 비싸서</label>
            </div>
          </li>
          <li>
            <div class="radio-style">
              <input
                id="reason04"
                v-model="cancelDescription"
                type="radio"
                class="radio-pink"
                name="reason"
                value="서비스 장애나 에러가 많아서"
              />
              <label for="reason04">서비스 장애나 에러가 많아서</label>
            </div>
          </li>
          <li>
            <div class="radio-style">
              <input
                id="reason05"
                v-model="cancelDescription"
                type="radio"
                class="radio-pink"
                name="reason"
                checked=""
                value="타 서비스를 이용하기 때문에"
              />
              <label for="reason05">타 서비스를 이용하기 때문에</label>
            </div>
          </li>
          <li>
            <div class="radio-style">
              <input
                id="reason06"
                v-model="cancelDescription"
                type="radio"
                class="radio-pink"
                name="reason"
                value="other"
              />
              <label for="reason06">다른 사유</label>
            </div>
          </li>
          <li>
            <textarea
              v-model="cancelDescriptionOther"
              placeholder="사유를 입력해주세요."
              :disabled="cancelDescription !== 'other'"
            ></textarea>
          </li>
        </ul>
        <span class="con-tit">해지신청을 계속하시겠습니까?</span>
        <div class="btn-pink">
          <a href="#" @click.prevent="close()">취소</a>
        </div>
        <div class="tar">
          <a href="#" class="gray-arrow" @click.prevent="unsubscribe()"
            >해지하기</a
          >
        </div>
      </div>
    </template>

    <!-- NOTE: case3.1-밖에서 해지취소 버튼 클릭 시 프로모션유저인경우 첫번째 스텝 -->
    <template v-else-if="!isUnsubscribe && step === 0">
      <div class="defend-top defend-info01">
        <GiftCoin alt="gift-coin" />
        <h1>감사합니다.</h1>
        <p>
          자동결제 해지신청을 취소하면 선물을 드려요.<br />
          선물을 받으시겠어요?
        </p>
      </div>
      <div class="defend-contents">
        <span class="con-tit">이용권 유지 혜택!</span>
        <span
          v-for="(message, index) in dataUnsubscribe.promotiontext1"
          :key="'promotion_' + index"
          class="con-dotted"
        >
          <i class="icon-dotted"></i>
          <span v-html="message"></span>
        </span>
        <div class="btn-pink marB0">
          <a href="#" @click.prevent="step++">해지 취소하고 선물 받기</a>
        </div>
      </div>
    </template>

    <!-- NOTE: case3.2-프로모션 미적용 유저의 해지취소 첫 화면 / 해지 취소 재확인 -->
    <template v-else-if="!isUnsubscribe && step === 1">
      <div class="defend-contents defend-type01 tac">
        <h1>감사합니다.</h1>
        <span class="con-txt con-txt01">
          해지신청을 취소하겠습니까?<br />
          <span class="fc-pink">취소 시 자동결제가 재개됩니다.</span>
        </span>
        <div class="btn-pink marB0">
          <a href="#" @click.prevent.once="cancelUnsubscribe()">확인</a>
        </div>
      </div>
    </template>

    <!-- NOTE: case3.3-해지 취소 완료 -->
    <template v-else-if="!isUnsubscribe && step === 2">
      <div class="defend-contents defend-type01 tac">
        <h1>감사합니다.</h1>
        <span
          v-if="dataUnsubscribe && dataUnsubscribe.promotiontext2.length"
          class="con-txt con-txt01"
          v-html="dataUnsubscribe.promotiontext2[0]"
        ></span>
        <span v-else class="con-txt con-txt01">해지신청이 취소되었습니다.</span>
        <span
          v-if="dataUnsubscribe && dataUnsubscribe.eventype === 'coin'"
          class="con-dotted marT30 tal"
        >
          <i class="icon-dotted"></i>
          다음 결제일에 이용권이 정상결제됩니다.
        </span>
        <span
          v-if="dataUnsubscribe && dataUnsubscribe.eventype === 'coin'"
          class="con-dotted tal"
        >
          <i class="icon-dotted"></i>
          코인은 [MY > 코인내역]에서 확인하실 수 있습니다.
        </span>
        <span
          v-if="dataUnsubscribe && dataUnsubscribe.eventype === 'coin'"
          class="con-dotted tal"
        >
          <i class="icon-dotted"></i>
          보너스 코인을 사용한 경우 전자상거래법 등 관련 법률에 따라 해지 신청이
          제한될 수 있습니다.
        </span>
        <span
          v-if="dataUnsubscribe && dataUnsubscribe.eventype === 'coin'"
          class="con-dotted tal"
        >
          <i class="icon-dotted"></i>
          웨이브 코인: 방송VOD/영화 단건 구매 시 사용 가능
        </span>
        <div class="btn-pink marB0">
          <a href="#" @click.prevent="complete">확인</a>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { get } from 'lodash'
  import CloseWhite from '@/assets/svg/common/search-white-normal.svg'
  import Ticket from '@/assets/svg/common/ticket-noti.svg'
  import GiftCoin from '@/assets/svg/common/gift-coin-2.svg'
  import { MyPooqService, VoucherService } from '@/common/api/api.service'
  import { MSG_MYPOOQ_COMPLETE_UNSUBSCRIBE } from '@/common/constant'
  import { enableBodyScroll } from '@/common/util/ui.utils'
  import NextButtonBlack from '@/assets/svg/common/ic-next-s-g.svg'
  import utils from '@/common/util/utils'
  import { isApp } from '@/common/util/common'

  const ALREADY_RECEIVE_COIN =
    '이미 참여하셨어요. \n본 혜택은 1회만 제공받을 수 있어요.'
  export default {
    name: 'RevocationDefense',
    components: {
      CloseWhite,
      Ticket,
      GiftCoin,
      NextButtonBlack,
    },
    props: {
      voucherData: {
        type: Object,
      },
      close: {
        type: Function,
      },
      userServiceId: {
        type: String,
      },
      endDate: {
        type: String,
      },
      isUnsubscribe: {
        type: Boolean,
      },
    },
    data() {
      return {
        dataUnsubscribe: undefined,
        promotionMessage: undefined,
        coinText: undefined,
        step: -1,
        isGetRewords: false,
        isShow: false,
        cancelDescription: '찾는 콘텐츠가 별로 없어서', // 해지 사유getPassPromotion
        cancelDescriptionOther: '', // 해지 기타 사유
        getCoin: false,
        highlightTextStyle: {
          color: '#fff',
          textDecoration: 'underline',
        },
      }
    },
    computed: {
      remainingTime() {
        if (this.voucherData && this.voucherData.enddate) {
          return (
            this.voucherData.enddate.substring(0, 4) +
            '.' +
            this.voucherData.enddate.substring(5, 7) +
            '.' +
            this.voucherData.enddate.substring(8, 10)
          )
        }
        return ''
      },
      voucherDescription() {
        const description = this.voucherData.attributetext || ''
        return description.replace(
          /\$O\$/gi,
          '<span class="icon-dotted"></span>',
        )
      },
      isUpcomingpayment() {
        return this.voucherData && this.voucherData.upcomingpayment
      },
    },
    created() {
      enableBodyScroll()
      if (!this.isUnsubscribe) {
        MyPooqService.myPurchasePassPromotionContinue(
          { packagemasterid: this.voucherData.packagemasterid },
          (err) => {
            if (err.response && err.response.status === 551) {
              this.step = 1
              this.isShow = true
            }
          },
        ).then((response) => {
          this.step = 0
          this.isShow = true
          this.dataUnsubscribe = response.data
        })
      } else {
        this.step = 0
        this.isShow = true
      }
    },
    methods: {
      // 해지방어 프로모션 대상자인지 체크
      checkPromotion() {
        MyPooqService.getPassPromotion(
          { packagemasterid: this.voucherData.packagemasterid },
          (error) => {
            this.getCoin = true
            if (error.response && error.response.status === 551) {
              // NOTE: 자동결제예정 이용권은 keyId를 '0'으로 보낸다.
              MyPooqService.passPromotionCancel({
                productType: 'pass',
                keyId: this.isUpcomingpayment ? '0' : this.userServiceId,
                status: 0,
              }).then((res) => {
                if (res.status === 200) {
                  utils.alert(MSG_MYPOOQ_COMPLETE_UNSUBSCRIBE)
                  this.$router.back()
                }
              })
            }
          },
        ).then(() => {
          this.getPromotionData()
        })
      },
      // 해지방어 프로모션 데이터를 가져온다.
      getPromotionData() {
        VoucherService.getPromotionVoucherList().then((response) => {
          if (!this.getCoin) {
            this.step = 1
          }
          response.data.forEach((data) => {
            if (data.packagemasterid === this.voucherData.packagemasterid) {
              this.promotionMessage = data.message
              this.coinText = data.cointext
            }
          })
        })
      },
      // 유지하고 코인 받기
      getRewords() {
        MyPooqService.myPurchasePassEvent({ eventType: 'cancelpass' }).then(
          () => {
            this.isGetRewords = true
          },
        )
      },
      // 해지방어 팝업 내 자동결제 해지
      unsubscribe() {
        MyPooqService.passPromotionCancel({
          productType: 'pass',
          keyId: this.userServiceId,
          status: 0,
        }).then(() => {
          utils.alert(MSG_MYPOOQ_COMPLETE_UNSUBSCRIBE, () => {
            // this.$router.replace({ name: 'subscription_ticket' })
            this.$router.replace(
              `/mypooq/subscription_ticket?targetdm=${get(this.$route, ['query', 'targetdm'], '')}`,
            )
          })
        })
      },
      // 해지 사유 전송  //INFO: 더이상 사용하는 곳이 없는듯
      // postCancelDescription () {
      //   this.$api.post.userPurchaseCancel(this.cancelDescription === 'other'
      //     ? this.cancelDescriptionOther : this.cancelDescription)
      // },
      // 자동결제 해지 취소
      cancelUnsubscribe() {
        // 2차 해지방어 대상자이고 코인 지급 타입일 때
        if (this.dataUnsubscribe && this.dataUnsubscribe.eventype === 'coin') {
          MyPooqService.myPurchasePassEvent(
            { eventType: 'continuepass' },
            (err) => {
              if (err.response && err.response.status === 550) {
                let message = err.response.data.resultmessage
                  ? err.response.data.resultmessage
                  : '서버에서 알 수 없는 오류가 발생했습니다.'
                message =
                  message.indexOf('이미') > -1 ? ALREADY_RECEIVE_COIN : message
                utils.alert(message)
              }
            },
          ).then(() => {
            MyPooqService.passPromotionCancel({
              productType: 'pass',
              keyId: this.voucherData.userserviceid,
              status: 1,
            }).then(() => {
              this.step = 2
            })
          })
        } else {
          // NOTE: 자동결제예정 이용권은 keyId를 '0'으로 보낸다.
          MyPooqService.passPromotionCancel({
            productType: 'pass',
            keyId: this.isUpcomingpayment
              ? '0'
              : this.voucherData.userserviceid,
            status: 1,
          }).then(() => {
            this.step = 2
          })
        }
      },
      // 자동결제 해지 취소 완료
      complete() {
        // this.$router.replace({ name: 'subscription_ticket' })
        this.$router.replace(
          `/mypooq/subscription_ticket?targetdm=${get(this.$route, ['query', 'targetdm'], '')}`,
        )
      },
      getInquiryUrl() {
        return isApp()
          ? 'captvpooq://customer/qna/inquiry'
          : 'https://member.wavve.com/mobile/customer/qna/ask?device=mobile'
      },
    },
  }
</script>
